module.exports = __webpack_public_path__ + "static/media/zoomy1.5f2f807a.jpg";